module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }